export const tech = [
    {
        Title:"React",
        Content:"React makes it painless to create interactive UIs. Design simple views for each state in your application, and React will efficiently update and render just the right components when your data changes.",
    },
    {
        Title:"WebXR",
        Content:"WebXR, with the WebXR Device API at its core, provides the functionality needed to bring both augmented and virtual reality (AR and VR) to the web. Mixed reality is a large and complex subject, with much to learn and many other APIs to bring together to create an engaging experience for users.",
    },
    {
        Title:"Three.js",
        Content:"Three.js allows the creation of graphical processing unit (GPU)-accelerated 3D animations using the JavaScript language as part of a website without relying on proprietary browser plugins. This is possible due to the advent of WebGL, a low-level graphics API created specifically for the web.",
    },
    {
        Title:"MindAR.js",
        Content:"MindAR is an opensource web augmented reality library. It supports Image Tracking and Face Tracking. MindAR started with AFRAME integration. Starting from version 1.1.0. MindAR support direct integration with three.js. ",
    },
    {
        Title:"Tailwind",
        Content:"Tailwind CSS is a low-level framework. Meaning, unlike other CSS frameworks like Bootstrap and Materialize, Tailwind doesn't offer fully styled components like buttons, dropdowns, and navbars. Instead, it offers utility classes so you can create your own reusable components.",
    },
    {
        Title:"OCR",
        Content:"OCR stands for Optical Character Recognition. It is a widespread technology to recognize text inside images, such as scanned documents and photos. OCR technology is used to convert virtually any kind of image containing written text (typed, handwritten, or printed) into machine-readable text data.",
    }
    
];